/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { Storage } from 'aws-amplify';

type CardNetwork = 'AMEX' | 'VISA' | 'MASTERCARD';
type CardTransactionType = 'AUTHORIZED' | 'CLEARED' | 'RETURNED';
type ExportJobType = 'CTE' | 'CLOF' | 'KEY_METRICS';
type CardFulfillmentType = 'PENDING' | 'FULFILLMENT';
type RunForDateType = 'CARD_TRANSACTION' | 'WALLET_PAYOUT';

type ExportJobStatus = {
  uuid: string;
  s3Bucket: string;
  s3Filename: string;
  exportJobType: string;
  jobCompleted: boolean;
  createdAt: string;
  merchantName: string;
  venueName: string;
  nextExecutionParameters: CSVParams;
};

type CSVParams = {
  startDate?: string;
  endDate?: string;
  merchantId?: string;
  venueId?: string;
  cardNetwork?: CardNetwork;
  cardTransactionType?: CardTransactionType;
  cardFulfillmentType?: CardFulfillmentType;
  exportJobType?: ExportJobType;
  runForDateType?: RunForDateType;
  userIdentityId?: string;
  venueType?: string;
  cashbackPercentage?: number;
  cashbackAmount?: number;
};

const downloadBlob = (blob: Blob, name: string) => {
  const blobUrl = URL.createObjectURL(blob);
  const link = document.createElement('a');

  // Set link's href to point to the Blob URL
  link.href = blobUrl;
  link.download = name;

  // Append link to the body
  document.body.appendChild(link);

  // Dispatch click event on the link
  // This is necessary as link.click() does not work on the latest firefox
  link.dispatchEvent(
    new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window,
    }),
  );

  // Remove link from body
  document.body.removeChild(link);
};

const downloadS3File = async (s3Filename: string) => {
  const file = await Storage.get(s3Filename, {
    bucket: process.env.REPORTS_BUCKET,
    download: true,
    expires: 300,
    ContentType: 'text/csv',
    region: process.env.AWS_REGION,
  });
  const fileName = s3Filename.split('/');
  const blob = new Blob([file.Body], { type: 'octet/stream' });

  downloadBlob(blob, fileName[fileName.length - 1]);
};

export { ExportJobStatus, CSVParams, downloadS3File, CardNetwork };
